import { client as gameStateClient } from "@aura-frontend/wgs-client";

import { createLoggedFetch } from "@/utils/logged-fetch";
import { registerSupabaseHttpInterceptor } from "@/utils/register-supabase-http-interceptor";

/**
 * The wgs-client is generated from the win-game-service OpenAPI spec, whose
 * routes live under /api. Game state traffic goes through the WIN API instead,
 * which relays /game-state/<path> to win-game-service /api/<path> after
 * authorizing the caller with the same Supabase token.
 */
const GSM_PATH_PREFIX = "/api/";
const WIN_API_PATH_PREFIX = "/game-state/";

export const configureGameStateClient = () => {
  registerSupabaseHttpInterceptor(gameStateClient);

  gameStateClient.interceptors.request.use((request) => {
    const url = new URL(request.url);
    if (!url.pathname.startsWith(GSM_PATH_PREFIX)) {
      return request;
    }
    url.pathname =
      WIN_API_PATH_PREFIX + url.pathname.slice(GSM_PATH_PREFIX.length);
    return new Request(url, request);
  });

  gameStateClient.setConfig({
    ...gameStateClient.getConfig(),
    baseUrl: import.meta.env.VITE_API_BASE_URL_WIN,
    // Uses Sentry's fetch wrapper and logs request durations (see App.tsx)
    fetch: createLoggedFetch("game-state"),
  });
};

export { gameStateClient };
